import { render, staticRenderFns } from "./AppTableHeaderCol.vue?vue&type=template&id=b70b7900"
import script from "./AppTableHeaderCol.vue?vue&type=script&lang=js"
export * from "./AppTableHeaderCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports